import { render, staticRenderFns } from "./RatingCheckDepartmentRatingDirectionsIndex.vue?vue&type=template&id=07324f16"
import script from "./RatingCheckDepartmentRatingDirectionsIndex.vue?vue&type=script&lang=js"
export * from "./RatingCheckDepartmentRatingDirectionsIndex.vue?vue&type=script&lang=js"
import style0 from "./RatingCheckDepartmentRatingDirectionsIndex.vue?vue&type=style&index=0&id=07324f16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports